module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Slider wraps one or two <code>&lt;inputs&gt;</code> [type=range] represented as slider with one\nor two handlers. When used in its vertical mode the Slider must be nested in a container with specific\nheight defined on it.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Slider name=&quot;slider__input&quot; value={[50,100]} orientation=&quot;horizontal&quot; /&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Slider/README.md
// module id = 386
// module chunks = 0